
import { Component, Vue } from 'vue-property-decorator'
import { MemberIVO, SlvMemberJoinVO } from './vo/join.vo'
import Constants from '@/constants'
import axios from 'axios';
import VueRecaptcha from 'vue-recaptcha';
import CommonUtils from '@/common-utils';
import Terms from '@/views/biz/privacy/Terms.vue';
import PrivacyPolicy from '@/views/biz/privacy/PrivacyPolicy.vue';
import CommonModalDialog from '@/components/CommonModalDialog.vue'
import { MstCountryVO } from '@/views/biz/country/vo/country.vo';

@Component({
  components: {VueRecaptcha, CommonModalDialog, Terms, PrivacyPolicy}
})
export default class Join extends Vue{

  member: MemberIVO = {} as MemberIVO;
  countries: Array<MstCountryVO> = [] as Array<MstCountryVO>;
  memPwd2 = '';

  isVerifyRecaptchaToken = false

  showTerms1 = false; // 이용약관
  showTerms2 = false;// 개인정보보호정책

  // 리캡차 이벤트
  verify(r) {
    console.log(r)
    this.member.reCaptchaAuthToken = r;
    this.isVerifyRecaptchaToken = true;
  }

  error() {
    this.isVerifyRecaptchaToken = false;
    console.log('error')
  }
 
  expired(r) {
    this.isVerifyRecaptchaToken = false;
    console.log('리캡차 응답 토큰 만료')
  }

  save() {
    if(!this.member.memNm) {
      // 이름을 입력해주세요.
      return alert(this.$t('join.a0039').toString());
    }

    if(!this.member.repCountryCd) {
      // 국가를 선택해주세요.
      return alert(this.$t('join.a0046').toString());
    }
    if(!this.member.memEmail) {
      //이메일주소를 입력해주세요.
      return alert(this.$t('join.a0040').toString());
    }
    
    if(Constants.REGEXP_EMAIL.test(this.member.memEmail) == false) {
      //이메일주소 형식이 올바르지 않습니다.
      return alert(this.$t('join.a0041').toString());
    }
    if(this.isVerifyRecaptchaToken == false) {
      // 인증이 필요합니다(리캡차)
      return alert(this.$t('join.a0036').toString());
    }

    if(CommonUtils.validatePassword(this.member.memPwd) == false) {
      // 비밀번호는 영어와 숫자 조합으로 8자 이상 16자 이하로 입력해야 합니다.
      return alert(this.$t('join.a0005').toString());
    }

    if(this.member.memPwd != this.memPwd2) {
      // 비밀번호가 일치하지 않습니다.
      return alert(this.$t('join.a0037').toString());
    }

    axios.post('/join/member/email', this.member).then(r=>{
      this.$router.push({name: 'JoinComplete'})
    }).catch(e=>{
      this.isVerifyRecaptchaToken = false;
      (this.$refs.reCaptcha as VueRecaptcha).reset();
    })

  }
  created() {
    axios.get("/join/member/countries").then((r) => {        
      this.countries = r.data;
    });      
  }
}
